import React from 'react';

import {MyScoresWidgetCompetitionTitlePlaceholder} from "./my-scores-widget.competition-title.placeholder";
import {GameCardPlaceholderComponent} from "../../../../core/components/game-card/components/game-card.placeholder";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class MyScoresWidgetCompetitionPlaceholderComponentProps extends BaseProps {
  numOfGames: Number = 4;
}

export const MyScoresWidgetCompetitionPlaceholder = (props: MyScoresWidgetCompetitionPlaceholderComponentProps) => {
  const games: Array<Object> = [];


  for (let i = 0; i < props.numOfGames; i++) {
    games.push({
      key: i,
    });
  }

  return (
    <div className={'my-scores-widget-placeholder-competition-container'}>
      <MyScoresWidgetCompetitionTitlePlaceholder {...props} />
      {
        games.map((placeholderProps) => <GameCardPlaceholderComponent {...placeholderProps} {...props}/>)
      }
    </div>
  )
}
